<template lang="pug">
  .photo-card(:key="requestItem.id" v-if="!requestItem.delivery" :class="requestItem.status")
    .photo-header
      .status-badge.mr-2(:class="requestItem.status") {{ ASSIGNMENT_ITEM_STATUS_TEXT[requestItem.status] }}
    .photo-body(@click="$emit('openImage', requestItem)")
      img(:src="requestItem.photoUrl" class="photo-thumbnail")
    .photo-footer
      template(v-if="requestItem.status === 'PENDING'")
        b-button.mr-2(variant="success" size="sm" @click.stop="approveRequestItem(requestItem)") Aprobar
        b-button(variant="danger" size="sm" @click.stop="rejectRequestItem(requestItem)") Rechazar
</template>

<script>
import { ASSIGNMENT_ITEM_STATUS, ASSIGNMENT_ITEM_STATUS_TEXT } from '@/constants/assignmentItemStatus'
import StatusBadge from '@/components/common/StatusBadge.vue'
import moment from 'moment-timezone'

export default {
  name: 'RequestItemCard',
  components: {
    StatusBadge
  },
  props: {
    requestItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      ASSIGNMENT_ITEM_STATUS,
      ASSIGNMENT_ITEM_STATUS_TEXT,
      selected: false
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY')
    },
    isSelectableItem(item) {
      return item.status === ASSIGNMENT_ITEM_STATUS.PENDING
    },
    approveRequestItem(item) {
      this.$emit('approve', item)
    },
    rejectRequestItem(item) {
      this.$emit('reject', item)
    },
  },
  watch: {
    selected() {
      this.$emit('selectionChange', { requestItem: this.requestItem, selected: this.selected })
    }
  }
}
</script>

<style scoped>
.photo-card {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  width: 200px;
  display: flex;
  flex-direction: column;
  margin: auto;
}

.photo-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.photo-card.REJECTED {
  background-color: #f8d7da;
  border-color: #f5c6cb;
}

.photo-card.ACCEPTED {
  background-color: #d4edda;
  border-color: #c3e6cb;
}

.photo-card.PENDING {
  background-color: #fff3cd;
  border-color: #ffeeba;
}

.photo-header {
  padding: 0.5rem;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.photo-card.REJECTED .photo-header {
  background-color: #f8d7da;
  border-bottom-color: #f5c6cb;
}

.photo-card.ACCEPTED .photo-header {
  background-color: #d4edda;
  border-bottom-color: #c3e6cb;
}

.photo-card.PENDING .photo-header {
  background-color: #fff3cd;
  border-bottom-color: #ffeeba;
}

.photo-body {
  width: 100%;
  height: 150px;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  background-color: #000;
}

.photo-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.photo-footer {
  padding: 0.5rem;
  font-size: 0.75rem;
  text-align: center;
  color: #6c757d;
  background-color: #f8f9fa;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
}

.status-badge {
  text-align: center;
  width: 110px;
  height: 25px;
  border-radius: 10px;
  font-size: 15px/19px;
  font-weight: 600;
  padding-top: 1px;
}

.assigned-to-another-driver-warning {
  color: var(--warning);
  font-weight: 500;
  display: flex;
  align-items: center;
  font-size: 0.7rem;
  gap: 0.2rem;
}

.status-badge.PENDING {
  background-color: var(--warning);
  color: #333333;
}

.status-badge.ACCEPTED {
  background-color: var(--success);
  color: #fff;
}

.status-badge.REJECTED {
  background-color: var(--danger);
  color: #fff;
}

.tags-badge {
  background-color: #FFE45F;
  color: #264848;
}
</style>